import { render, staticRenderFns } from "./ExSearchTablePagination.vue?vue&type=template&id=2de7055c"
import script from "./ExSearchTablePagination.vue?vue&type=script&lang=js"
export * from "./ExSearchTablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports